/**
 * qrcodeCourse
 * Created by john
 * Date: 2019-07-16
 * Email: maiqingqiang@gmail.com
 * Time: 22:28
 */
import entityFactory from './entityFactory';
import {bindActionCreators} from "redux";

const namespace = 'course';

export const {types, actions, reducer} = entityFactory(namespace, {payload: []}, {}, {
    [`${namespace}/SUCCESS`]: (state, action) => {
        return {
            ...state,
            isFetching: false,
            isCompleted: true,
            payload: action.payload
        }
    }
});

export default reducer;

export const getCourse = state => state.entities.course;

export const getCourseActions = dispatch => bindActionCreators(actions, dispatch);